import { ROLE_NAME } from '@shootsta/common-domain-data';

export default function isShootstaSeniorEditorRoleName(roleName, status) {
  return ROLE_NAME.SHOOTSTA_SENIOR_EDITOR === roleName && status === 'ACCEPTED';
}